import Icon from '../../../atoms/Icon';
import BodyText from '../../../atoms/BodyText';
import React from 'react';
import Title from '../../../atoms/Title';
import * as styles from './companyProfileDetails.linaria';
import CompanyProfileLink from '../CompanyProfileLink';
function CompanyProfileDetails({ company, learnMoreAboutCertificatesURLPath, linkComponent, className, }) {
    var _a, _b, _c, _d, _e;
    return (<div className={className}>
      <div className={styles.organizationDetailsWrapper}>
        <Title size="small">Om bedriften</Title>

        {(company === null || company === void 0 ? void 0 : company.organizationNumber) && (<BodyText size="small" tag="span" className="organizationId textLine">
            Orgnr: {company === null || company === void 0 ? void 0 : company.organizationNumber}
          </BodyText>)}
        {(company === null || company === void 0 ? void 0 : company.address) && (<BodyText size="small" tag="span" className="textLine">
            <Icon icon="Location" size="small" className="iconWrapper"/>
            {company === null || company === void 0 ? void 0 : company.address}
          </BodyText>)}
        {(company === null || company === void 0 ? void 0 : company.companyWebsiteUrl) && (<div className="company-web-url">
            <Icon icon="MailArrow" size="small" className="iconWrapper"/>
            <CompanyProfileLink url={company === null || company === void 0 ? void 0 : company.companyWebsiteUrl} openInNewTab underline={false} linkComponent={linkComponent}>
              <BodyText size="small" tag="span" className="textLine text-break-wrapper">
                {company === null || company === void 0 ? void 0 : company.companyWebsiteUrl}
              </BodyText>
            </CompanyProfileLink>
          </div>)}

        {(company === null || company === void 0 ? void 0 : company.phone) && (<BodyText size="small" tag="span" className="textLine">
            <Icon icon="Chat" size="small" className="iconWrapper"/>
            {company === null || company === void 0 ? void 0 : company.phone}
          </BodyText>)}
        <div className="labelsWrapper">
          {(_a = company === null || company === void 0 ? void 0 : company.industryAssociations) === null || _a === void 0 ? void 0 : _a.map((value) => (<BodyText key={value} size="small" tag="span" className="labelTextWrapper">
              {value}
            </BodyText>))}
        </div>
        <div className="divider"/>
        <div className="certificate-wrapper">
          <BodyText size="small" tag="span" className="textLine certificate-title">
            Sertifiseringer
          </BodyText>
          {((_b = company === null || company === void 0 ? void 0 : company.certificates) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (<>
              <div className="certificate-image-wrapper">
                {(_c = company === null || company === void 0 ? void 0 : company.certificates) === null || _c === void 0 ? void 0 : _c.map((value) => (<img key={value.name} className="certificate-image" src={value === null || value === void 0 ? void 0 : value.logoImage} alt={value === null || value === void 0 ? void 0 : value.displayName}/>))}
              </div>
            </>) : (<>
              <BodyText size="small" tag="span" className="textLine no-certificates-text">
                Mangler informasjon
              </BodyText>
            </>)}
          <div className="learn-more-certificates-text">
            <CompanyProfileLink url={learnMoreAboutCertificatesURLPath} openInNewTab underline linkComponent={linkComponent}>
              <div className="learn-more-certificates-text-items">
                <BodyText tag="span">Les mer om sertifiseringer</BodyText>
                {linkComponent && (<Icon className="arrow-icon" icon="ArrowRight" size="small"/>)}
              </div>
            </CompanyProfileLink>
          </div>
        </div>

        {((_d = company === null || company === void 0 ? void 0 : company.franchiserCompanies) === null || _d === void 0 ? void 0 : _d.length) > 0 && (<>
            <div className="divider"/>
            <div className="certificate-wrapper">
              <BodyText size="small" tag="span" className="textLine certificate-title">
                Kjedetilhørighet
              </BodyText>

              <div className="certificate-image-wrapper">
                {(_e = company === null || company === void 0 ? void 0 : company.franchiserCompanies) === null || _e === void 0 ? void 0 : _e.map((value) => (<span key={value === null || value === void 0 ? void 0 : value.organizationNumber}>
                    {(value === null || value === void 0 ? void 0 : value.franchiserLogoPath) ? (<img className="franchiser-image" alt={value === null || value === void 0 ? void 0 : value.name} src={value === null || value === void 0 ? void 0 : value.franchiserLogoPath}/>) : (<BodyText className="franchiser-image" size="small" tag="span">
                        {value === null || value === void 0 ? void 0 : value.name}
                      </BodyText>)}
                  </span>))}
              </div>
            </div>
          </>)}
      </div>
    </div>);
}
CompanyProfileDetails.defaultProps = {
    className: null,
    linkComponent: null,
};
export default CompanyProfileDetails;
